import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import './App.css';
import { defaultTheme } from './theme';
import { visionTheme } from './theme';
import Root from './components/Root/Root';

const App: React.FC = () => {
  const mode = import.meta.env.VITE_DO_MODE || 'matrix';
  const theme = mode === 'vision' ? visionTheme : defaultTheme;

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <Root></Root>
    </MuiThemeProvider>
  );
};

export default App;
